export enum Brand {
  CETELEM = 'cetelem',
  CMOI = 'cmoi',
  CMAG = 'cmag',
  CAFINEO = 'cafineo',
  DOMOFINANCE = 'domofinance',
}
